<template>
  <edit :module="module" :moduleId="id" :displayError="displayError" @save="save"
        @draftSaved="unsavedDraft = false"/>
</template>

<script>
import User from "@/services/api/authUser";
import dataStore from "@/services/api/store";
import edit from "../detail";
const COURSE_MODULE_STORE = "CoachCourseModules";
import snackbar from "@/services/hubs/snackbar";

export default {
  props: ["id"],
  components: {
    edit
  },
  data() {
    return {
      displayError: "",
      userId: User.id,
      module: {},
      unsavedDraft: false
    };
  },
  created() {
    dataStore
      .find(COURSE_MODULE_STORE, this.id, { force: true })
      .then(result => {
        this.module = result;
      });
    window.addEventListener("input", this.inputListener.bind(this));
    window.addEventListener(
      "beforeunload",
      this.beforeUnloadListener.bind(this)
    );
  },
  // vue route change
  beforeRouteLeave(to, from, next) {
    if (this.unsavedDraft) {
      let leave = window.confirm(
        "Are you sure you want to leave? You may have unsaved progress."
      );
      if (leave) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  beforeDestroy() {
    window.removeEventListener("input", this.inputListener.bind(this));
    window.removeEventListener(
      "beforeunload",
      this.beforeUnloadListener.bind(this)
    );
  },
  methods: {
    save(mod) {
      dataStore
        .update(COURSE_MODULE_STORE, mod.id, mod)
        .then(module => {
          this.module = module;
          this.displayError = "";
          this.$emit("displaySnackbar", "Saved");
          snackbar.update("Saved");
        })
        .catch(() => {
          this.displayError = "An error occurred";
        });
      this.unsavedDraft = false;
    },
    addExercise() {},
    inputListener() {
      this.unsavedDraft = true;
    },
    beforeUnloadListener(event) {
      // window route change
      if (this.unsavedDraft) {
        event.returnValue =
          "Are you sure you want to leave? You may have unsaved progress.";
      }
    }
  }
};
</script>
